import { lazy } from 'react'

export const UniversityPage = lazy(() => import('./University'))
export const UniversityAddPage = lazy(() => import('./UniversityAdd'))
export const UniversityEditPage = lazy(() => import('./UniversityEdit'))